export const parametroState = {
    listado: [],
    isLoading: false,
    message: '',
    severity: '',
}